import { useState } from "react";
import { Lock, User, Eye } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

const HelperLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/helper/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || "Invalid username or password");
      }

      const data = await res.json();
      localStorage.setItem("helper_session", JSON.stringify(data.helper));
      onLogin(data.helper);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-[#00C2FF] to-[#00E054] flex items-center justify-center mx-auto mb-6 shadow-[0_0_60px_rgba(0,194,255,0.3)]">
            <Eye className="text-black" size={48} />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">WKBeast Farm</h1>
          <p className="text-gray-500">Staff Monitoring — View Only</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <User className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="pl-12 py-6 bg-[#0F0F0F] border-[#27272A] text-white text-lg"
              required
              data-testid="helper-username"
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="pl-12 py-6 bg-[#0F0F0F] border-[#27272A] text-white text-lg"
              required
              data-testid="helper-password"
            />
          </div>

          {error && (
            <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm text-center">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="w-full py-6 bg-[#00C2FF] text-black font-bold text-lg hover:bg-[#00C2FF]/90 transition-all hover:shadow-[0_0_30px_rgba(0,194,255,0.5)]"
            data-testid="helper-login-btn"
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>

        {/* Footer */}
        <p className="text-center text-gray-600 text-sm mt-8">
          Ask the admin if you need an account or forgot your password
        </p>
      </div>
    </div>
  );
};

export default HelperLogin;
